export enum FuelReportsReactQuery {
  GetFuelReportsFilterName = 'getFuelReportsFilterName'
}
